import cn from 'classnames/bind';
import { ActiveLink } from 'ui';

import s from './NavigationItemLink.module.css';

const cx = cn.bind(s);

const NavigationItemLink = ({
  children, href, className, append, childLinks, ...attrs
}) => (
  <ActiveLink className={cx('navItemLink')} href={href} childLinks={childLinks} activeClassName={cx('navItemLinkSelected')} {...attrs}>
    {children}
    { append || null}
  </ActiveLink>
);

export default NavigationItemLink;
